/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,DatePicker,
  Button
} from "shards-react";

const SidebarActions = ({ title,handleAddBlog,handleDateChange,selectedDate,handleUpdateBlog,isEdit,deleteFromDb }) => (
  <Card small className="mb-3">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{title}</h6>
    </CardHeader>

    <CardBody className="p-0">
      <ListGroup flush>
   
        <ListGroupItem className="d-flex px-3 border-0">
        <DatePicker
          size="xs"
          selected={selectedDate || new Date()}
          onChange={(e)=>handleDateChange(e,"dateOfPublishing")}
          placeholderText="Date of Publishing"
          dropdownMode="select"
          className="text-center"
        />
          <Button onClick={()=>isEdit ? handleUpdateBlog() : handleAddBlog('publish')} theme="accent" size="sm" className="ml-auto">
            <i className="material-icons">file_copy</i> {isEdit ? 'Update' : 'Publish'}
          </Button>
        </ListGroupItem>
       {isEdit ?  <ListGroupItem className="d-flex px-3 border-0">
      
          <Button onClick={()=>deleteFromDb()} theme="danger" size="xs" className="ml-auto">
            <i className="material-icons">file_copy</i>Delete
          </Button>
          <Link to="/Blog-posts" className="ml-auto"><Button theme="white" size="md" className="ml-auto">
            <i className="material-icons">file_copy</i> Cancel
          </Button></Link>
        </ListGroupItem> : ''}
      </ListGroup>
    </CardBody>
   
  </Card>
);

SidebarActions.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

SidebarActions.defaultProps = {
  title: "Actions"
};

export default SidebarActions;
